export default __webpack_public_path__ + "static/media/error.d4dcb83b.gif";